import constants from '@common/constants';
import useAuth from '@common/hooks/useAuth';
import useTrackOffer from '@common/hooks/useTrackOffer'; // TODO: renomear esse hook para um nome genério pq esta sendo usado em todo projeto
import { pageNames } from '@common/routes/pageNames';
import { useUser } from '@common/hooks/useUser';
import { MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { logoutPushWeb } from '@libs/jaiminho';
import { useRedline } from '@libs/redline';
import { CONSULTING_DEBT_SEARCH_PARAM } from '@dues/pages/MyDebts/hooks/ExperienceController/services/ExpressCheckout';

type UsePrivatePagesHandlersProps = {
  setShowLogoutModal: (prev: boolean) => void;
};

export const usePrivatePagesHandlers = ({ setShowLogoutModal }: UsePrivatePagesHandlersProps) => {
  const { trackElementClicked } = useTrackOffer();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useUser(); // TODO acp-migration: legacy field, remover
  const { logOut } = useAuth();
  const { track } = useRedline();

  const onClickBackMenu = () => {
    const currentPath = location.pathname;
    const currentHash = location.hash;

    const searchParams = new URLSearchParams(location.search);
    const consultingExpressParam = searchParams.get(CONSULTING_DEBT_SEARCH_PARAM);

    track.userTracking.elementClicked({
      name: 'go-back-btn',
      location: 'simple-header',
      elementType: 'button',
    });

    if (currentPath.endsWith('/confirmacao') && (currentHash === '#detalhes-da-divida' || currentHash === '#composicao-da-divida')) {
      navigate(currentPath);
      return;
    }

    const paths = ['acordo-fechado', 'confirmacao'];
    const shouldRedirect = paths.some((path) => currentPath.includes(path));

    if (shouldRedirect) {
      //#region AB Test - dx-itau-resume
      const stepParam = searchParams.get('step');
      if (currentPath.includes('confirmacao') && stepParam === '2') {
        navigate(`${currentPath}?step=1`);
        return;
      }
      //#endregion

      navigate(pageNames.myDebts.path, {
        state: {
          from: currentPath,
          consulting_express: consultingExpressParam,
        },
      });
      return;
    }

    navigate(-1);
  };

  function onClickLogout(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();

    trackElementClicked({
      name: 'sair',
      location: 'ac-logout-modal',
      elementType: 'button',
    });

    logoutPushWeb();

		const event = new CustomEvent("logout_trail", {
			detail: {
				trigger: 'on_click_logout',
			},
		});
		window.dispatchEvent(event);

    logOut();
    navigate(pageNames.signin.path);
  }

  function onClickNotLogout(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();

    trackElementClicked({
      name: 'sair-e-continuar-logado',
      location: 'ac-logout-modal',
      elementType: 'button',
    });

    // TODO acp-migration: validar cross-domain KEEP_SESSION (Task 18) antes de remover definitivamente.
    // Confirmar com time de outras apps em acordocerto.com.br que nenhuma lê KEEP_SESSION.
    // const oneHundredTwentyDays = new Date();
    // oneHundredTwentyDays.setDate(oneHundredTwentyDays.getDate() + 120);
    // addCookie({
    //   key: constants.auth.KEEP_SESSION,
    //   value: JSON.stringify(user),
    //   encrypt: true,
    //   expires: oneHundredTwentyDays,
    // });
    const isDev = import.meta.env.VITE_ENV === 'dev';
    const url = `https://${isDev ? 'dev.' : ''}acordocerto.com.br/`;
    window.open(url, '_self');
  }

  const onClickLogoutModal = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowLogoutModal(true);
  };

  return {
    onClickBackMenu,
    onClickLogout,
    onClickNotLogout,
    onClickLogoutModal,
  };
};
